module.exports = __webpack_public_path__ + "static/media/link.41dde9e1.svg";